<template>
  <div>
    <AccessHandler
      :requiredRoleGroups="roleGroups"
      @accessChanged="(a: boolean) => (hasAccess = a)"
    />
    <MasterPage>
      <template v-if="hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text" data-cy="company-rc-page-title">
            Chometz Sale Company List
          </h1>
        </header>
        <ChometzCompaniesTable />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import ChometzCompaniesTable from "./ChometzCompaniesTable.vue";
import MasterPage from "../MasterPage.vue";
import GlobalFooter from "@/views/GlobalFooter.vue";
import { ref } from "vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import type { RoleGroup } from "@/shared/access/RoleGroups";
import { UserRoles as Roles } from "@/Domain/UserRoles";

const roleGroups = [
  {
    roles: [...Roles.RolesChometzRcCompaniesApplication],
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>
